<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <info-card
            label="اسم الحملة"
            :value="data.name_ar"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="نوع الحملة"
            :value="data.campaign_type ? data.campaign_type.title : '' "
            />
        </b-col>   
        <b-col md="4" cols="12" v-if="data.hasOwnProperty('campaign_amount') && data.campaign_amount != null">
            <info-card label="مبلغ التبرع"
            :value="data.campaign_amount"
            />
        </b-col>    
        <b-col md="4" cols="12" v-if="data.hasOwnProperty('number') && data.number != null">
            <info-card label="العدد"
            :value="data.number"
            />
        </b-col>     
        <b-col md="4" cols="12" v-if="data.age_category_id">
            <info-card
            label="الفئات المستهدفة"
            :value="getLabelToShow(data.age_category_id)"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="تاريخ بداية الحملة"
            :value="data.start_date"
            />
        </b-col>   
        <b-col md="4" cols="12">
            <info-card label="تاريخ نهاية الحملة"
            :value="data.end_date"
            />
        </b-col>      
        <b-col md="4" cols="12">
            <info-card label="المحافظة"
            :value="data.governorate ? data.governorate.name_ar : '' "
            />
        </b-col>       
        <b-col md="4" cols="12">
            <info-card label="التفاصيل"
            :value="data.description_ar"
            />
        </b-col> 
        <b-col md="4" cols="12">
            <b-card class="profile-header">
                <div class="info-card w-100 px-2 py-1">
                    <h6
                    style="width: fit-content; padding: 4px 6px"
                    class="bg-info rounded mb-1 text-white font-weight-bold"
                    >
                    صورة الحملة 
                    </h6>
                    <div class="profile-img d-flex justify-content-center ">
                    <b-img
                        style="height: 50%; width: 50%"
                        :src="data.image"
                        rounded
                        fluid
                        alt="profile photo"
                    />

                    </div>
                    <hr />
                </div>

            </b-card>
        </b-col> 
        <b-col cols="12" v-if="Object.keys(annualPlan).length>0">
            <div>
                <h5 class="mx-1 mt-2">
                     الخطة السنوية لسنة {{annualPlan.current.year}}
                </h5>
                <hr />
            </div>
            
            <div>
            
                <plan-table
                :planDetails.sync="annualPlan.current.programs"
                :evaluated=true
                />
            </div>
            <div class="d-flex justify-content-between mt-2">
            <h4 class="d-flex align-items- center">
                <feather-icon class="mr-50" size="20" icon="CalendarIcon" />
                الأنشطة الطارئة
            </h4>
            </div>
            <hr />
            
                <plan-table
                :planDetails.sync="annualPlan.current.urgencies"
                isUrgent
                />
        </b-col>   
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  import axios from "@axios";
  import PlanTable from "@/modules/ngo/annual-plan/components/PlanTable.vue";
  
  import router from "@/router";
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton , PlanTable
    },
    props: {
        data : Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
    data() {
        return {
            annualPlan : {}
        };
    },
    methods :{
        getLabelToShow(value){
            return value.map(item => item.name_ar).join(', ');
        }
    },
    async mounted() {
        
        const currentRoute = router.currentRoute.path.includes('ministry')
        if(currentRoute){
            await axios.get(`v2/ministry/get-annual-plan-by-ngo/${this.data.ngo_id}`).then((res) => this.annualPlan = res.data.data);
        }
    },
  };
  </script>